import t from "react";
import { useEnvironment as c } from "../../../../../features/common/hooks/environment/useEnvironment.js";
import p from "../../hooks/customization/useCustomization.js";
import { NoReachStep as u } from "./steps/NoReachStep.js";
import { useOrdering as g } from "./context.js";
import h from "./landingForm.module.scss.js";
import d from "./steps/AddressStep.js";
import f from "./steps/RestaurantsStep.js";
import E from "./steps/TimeSelectorStep.js";
import S from "./steps/SingleRestaurantStep.js";
import { RestaurantRedirectionStep as R } from "./steps/RestaurantRedirectionStep.js";
function z() {
  var m, l, s;
  const {
    currentStep: r
  } = g(), {
    mapApiKey: i
  } = c(), {
    configuration: e
  } = p(), a = () => {
    const n = [];
    return e == null || e.settings.configuration.scope.forEach(({ countryCode: o = "" }) => {
      o.length === 0 || n.includes(o) || n.push(o);
    }), n;
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      "data-testid": "ordering-form",
      className: h.form,
      style: {
        color: e == null ? void 0 : e.design.colors.general.highlightText,
        "--highlighHighlightColor": ((s = (l = (m = e == null ? void 0 : e.design) == null ? void 0 : m.colors) == null ? void 0 : l.general) == null ? void 0 : s.highlightHighlight) ?? "#EA565C"
      }
    },
    r.name === "address" && /* @__PURE__ */ t.createElement(
      d,
      {
        autocomplete: {
          apiKey: i,
          country: a()
        }
      }
    ),
    r.name === "restaurant-selector" && /* @__PURE__ */ t.createElement(f, null),
    r.name === "single-restaurant" && /* @__PURE__ */ t.createElement(S, null),
    r.name === "time-selector" && /* @__PURE__ */ t.createElement(E, null),
    r.name === "no-reach" && /* @__PURE__ */ t.createElement(u, null),
    r.name === "restaurant-redirection" && /* @__PURE__ */ t.createElement(R, null)
  );
}
export {
  z as OrderingForm
};
//# sourceMappingURL=OrderingForm.js.map
